export var downloadFile = function downloadFile(file) {
  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var anchor = document.createElement('a');
  anchor.href = file;
  anchor.download = name;
  document.body.appendChild(anchor);
  anchor.style.display = 'none';
  anchor.click();
  anchor.remove();
};